import { Component, Input, OnInit } from '@angular/core';
import { User } from '@classes/user';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../authentication/auth.service';
import { AccountService } from '../services/account.service';
// import { environment } from '@environments/environment';
import { EnvConfigurationService } from '../services/env-configuration.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  @Input() isAuth: boolean = false;

  currentUser: User | null;

  environmentName = this.environment.application;
  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private translate: TranslateService,
    public envConfigurationService: EnvConfigurationService
  ) { }

  ngOnInit() {
    this.useLanguage('fr');
    this.accountService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }
  logout() {
    this.authService.logout();
  }

}
